var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.checkbox
    ? _c(
        "el-checkbox",
        {
          attrs: { disabled: _vm.disabled },
          on: { change: _vm.onCheckboxChanged },
          model: {
            value: _vm.checked,
            callback: function($$v) {
              _vm.checked = $$v
            },
            expression: "checked"
          }
        },
        [_vm._v(_vm._s(_vm.fieldMeta.name))]
      )
    : _c(
        "el-select",
        {
          attrs: { clearable: "", disabled: _vm.disabled },
          on: { change: _vm.onSelectChanged },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        _vm._l(_vm.options, function(opt) {
          return _c("el-option", {
            key: opt.id,
            attrs: { label: opt.label, value: opt.value }
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }